import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input, InputNumber, Switch } from 'antd'
import { useEffect } from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { selectSelectedFormQuestionOption } from '../../../../store/membership/FormQuestionOptionReducer'
import { requiredRule } from '../../../../utils/rules'
import { Localizable } from '../../../localizable/Localizable'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedFormQuestionOption())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="id"
        hidden
        style={{ display: 'none' }}
        rules={[]}
        noStyle
      >
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="name" rules={[]} label={'Internal name'}>
        <Input />
      </Form.Item>

      <Localizable.Input
        name="question"
        rules={[requiredRule()]}
        label={'Question'}
        max={45}
      />
      <Localizable.Input name="description" label={'Description'} max={70} />

      <Form.Item name={'required'} noStyle valuePropName="checked">
        <Switch />
      </Form.Item>

      <Form.Item name={'max'} rules={[]} label={'Max items'}>
        <InputNumber min={1} max={10} />
      </Form.Item>
    </Form>
  )
}

export default Update
